module.exports = __webpack_public_path__ + "img/vlogo.5024d6f0.png";